export default __webpack_public_path__ + "static/graphik-regular-web-0ce6144b426d97670ba7c93e85341b04.woff";